import type { App, InjectionKey } from 'vue'
import type { VueConstructor } from 'vue2'
import * as utils from './utils.js'

export { languageDefaultLocales } from './config'
export * from './utils'
export type * from './models/types'

export const i18nDataKey = Symbol('i18nDataKey') as InjectionKey<typeof utils>

export const plugin = {
  install (app: App, { betaCountries }: { betaCountries?: boolean } = {}) {
    if (typeof betaCountries === 'boolean') {
      utils.enableBetaCountries(betaCountries)
    }

    app.config.globalProperties.$i18nData = { ...utils }
  }
}

/**
 * Backwards compatibility for Vue 2 apps
 */
export const pluginVue2 = {
  install (Vue: VueConstructor, { betaCountries }: { betaCountries?: boolean } = {}) {
    if (typeof betaCountries === 'boolean') {
      utils.enableBetaCountries(betaCountries)
    }

    if (!Vue.prototype.$i18nData) {
      Object.defineProperty(Vue.prototype, '$i18nData', {
        value: { ...utils }
      })
    }
  }
}
